export interface IQuestion {
  title: string;
  description: string;
}

export const questions: Array<IQuestion> = [
  {
    title: 'Where can I buy tokens and NFTs of SpiderShib Inu?',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere at facilis corporis saepe, nemo quae quibusdam! Sint doloremque sequi tempora.',
  },
  {
    title: 'Where can I buy tokens and NFTs of SpiderShib Inu?',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere at facilis corporis saepe, nemo quae quibusdam! Sint doloremque sequi tempora.',
  },
  {
    title: 'Where can I buy tokens and NFTs of SpiderShib Inu?',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere at facilis corporis saepe, nemo quae quibusdam! Sint doloremque sequi tempora.',
  },
  {
    title: 'Where can I buy tokens and NFTs of SpiderShib Inu?',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere at facilis corporis saepe, nemo quae quibusdam! Sint doloremque sequi tempora.',
  },
];
